@if (crossSellProductsLength > 0) {
  <div class="cross-sell-products">
    <h5 class="cross-sell-products__title" i18n="@@productRelated.youTitle">You may also like</h5>
    @for (crossSellProduct of crossSellProducts?.slice(0, 2); track crossSellProduct; let i = $index) {
      <div class="cross-sell-products__item">
        <div class="cross-sell-products__item-image">
          <figure>
            <img [src]="crossSellProduct.imageUrl" alt="{{ crossSellProduct.descriptions[0].title }}" />
          </figure>
        </div>
        <div class="cross-sell-products__item-info">
          <div class="cross-sell-products__item-title">
            {{ crossSellProduct.descriptions[0].title }}
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="cross-sell-products__price">
              <app-product-price
                class="custom_price_format"
                [productPriceInfo]="crossSellProduct.price"
                [showDiscounted]="false"
              />
            </div>
            <div class="cross-sell-products__buy-button">
              <app-add-to-cart-template
                [cartProduct]="getCartCrossSellProduct(crossSellProduct)"
                [productId]="crossSellProduct.id"
                [productTitle]="crossSellProduct.descriptions[0].title"
                [includeQuantitySelector]="false"
                [small]="true"
                (addToCart)="checkModalAndAddToCart(crossSellProduct)"
              />
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}

<app-modal
  #modalErrorComponentCartMaxValue
  i18n-title="@@product.maxCartQuantityErrorTitle"
  title="Quantity Error"
  [closeBackDrop]="true"
  [modalClass]="'quantity-error__modal'"
  [sourceId]="'quantityErrorModalCartMaxValue' + uniqueModalId"
>
  <p i18n="@@product.maxCartQuantityErrorTextAux">
    There are too many products in your cart, please reduce the number of products selected.
  </p>
  <div class="quantity-error__buttons">
    <button type="button" class="btn btn-secondary" i18n="@@CLOSE" (click)="closeQuantityErrorCartMaxValueModal()">Close</button>
  </div>
</app-modal>
